import { Intent, Toaster, Position } from '@blueprintjs/core';
import printError from './printError';

/** Handles and shows the errors stored in the StatusContext */
export const AppToaster = Toaster.create({
  position: Position.TOP
});

export const toastError = (error) => {
  const errorMessage = printError(error);
  AppToaster.show({ message: errorMessage, intent: Intent.DANGER });
};

export const statusReducer = (state, action) => {
  switch (action.type) {
    case 'LOADING':
      return state.concat({
        id: action.id,
        active: true,
        apiAction: action.apiAction
      });
    case 'ERROR':
      return state.map((api) => {
        if (api.id === action.id) {
          return { ...api, error: true };
        }
        return api;
      });
    case 'READY':
      return state.filter((api) => !api.id === action.id);
    default:
      return state;
  }
};
